import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  TextField,
  Divider,
  Paper,
  Avatar,
  Chip,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  AppBar,
  Toolbar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Delete,
  Add,
  Remove,
  Close,
  Event,
  Inventory2,
  CalendarToday,
  Schedule,
  LocationOn,
  ArrowBack,
  CurrencyRupee,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  removeFromCart,
  updateQuantity,
  clearCart,
  addToCart,
  setCart,
} from "../redux/slices/cartSlice";
import BookingForm from "./Modals/BookNowForm";
import useAxios from "../useAxios";
import { useNavigate } from "react-router-dom";
const CartPage = ({ onBack }) => {
  const dispatch = useDispatch();
  const axiosData = useAxios();
  const navigate = useNavigate();
  const loggedInemail = useSelector((state) => state.auth.email);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [userDetails, setUserDetails] = useState();
  const cartItems = useSelector((state) => state.cart.items);
  const [bookingFormOpen, setBookingFormOpen] = useState(false);
  const [eventDate, setEventDate] = useState("");
  const [eventTime, setEventTime] = useState("");
  const [eventLocation, setEventLocation] = useState("");

  // Responsive breakpoints
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const handleQuantityChange = (id, value) => {
    const qty = Math.max(1, Number(value));
    dispatch(updateQuantity({ product_id: id, quantity: qty }));
  };
  useEffect(() => {
    //  const saved = localStorage.getItem("cart");
    // if (saved) {
    //   dispatch(setCart(JSON.parse(saved)));
    // }
    //loadCartFromDB();
  }, []);
  const loadCartFromDB = async () => {
    try {
      const storedAuth = localStorage.getItem("auth");
      if (storedAuth) {
        const parsed = JSON.parse(storedAuth);
        const response = await axiosData.get(`getCartData/${parsed.email}`);
        if (response.data && response.data.cart.items) {
          cartItems = response.data.cart.items;
          //dispatch(setCart(dataGet));
          // const storeData =dataGet.map((data)=>{
          //    dispatch(setCart(data));
          // })
        }
      }
    } catch (err) {
      console.error("Error loading cart from database", err);
    }
  };
  const incrementQuantity = async (id, currentQty) => {
    try {
      dispatch(updateQuantity({ product_id: id, quantity: currentQty + 1 }));
      const storedAuth = localStorage.getItem("auth");
      if (storedAuth) {
        const parsed = JSON.parse(storedAuth);
        await axiosData.put("editCartData", {
          email: parsed.email,
          product_id: id,
          quantity: currentQty + 1,
        });
      }
    } catch (err) {
      console.error("Error removing item from database", err);
    }
  };

  const decrementQuantity = async (id, currentQty) => {
    try {
      if (currentQty > 1) {
        dispatch(updateQuantity({ product_id: id, quantity: currentQty - 1 }));
        const storedAuth = localStorage.getItem("auth");
        if (storedAuth) {
          const parsed = JSON.parse(storedAuth);
          await axiosData.put("editCartData", {
            email: parsed.email,
            product_id: id,
            quantity: currentQty - 1,
          });
        }
      }
    } catch (err) {
      console.error("Error removing item from database", err);
    }
  };

  const handleRemove = async (id) => {
    try {
      dispatch(removeFromCart(id));
      // Also remove from database
      const storedAuth = localStorage.getItem("auth");
      if (storedAuth) {
        const parsed = JSON.parse(storedAuth);
        await axiosData.put("editCartData", {
          email: parsed.email,
          product_id: id,
          quantity: 0,
        });
      }
    } catch (err) {
      console.error("Error removing item from database", err);
    }
  };

  const handleClearCart = async () => {
    try {
      dispatch(clearCart());
      // Also clear from database
      const storedAuth = localStorage.getItem("auth");
      if (storedAuth) {
        const parsed = JSON.parse(storedAuth);
        await axiosData.delete(`deleteCartData/${parsed.email}`);
      }
    } catch (err) {
      console.error("Error clearing cart from database", err);
    }
  };
  const fetchUser = async (email) => {
    try {
      const response = await axiosData.get(`getUser/${email}`);
      if (response.data) {
        setUserDetails(response.data.user);
      }
    } catch (err) {
      console.error("User get error", err);
    }
  };

  useEffect(() => {
    const storedAuth = localStorage.getItem("auth");
    const parsed = JSON.parse(storedAuth);
    fetchUser(parsed?.email);
  }, []);

  useEffect(() => {
    // Set default event date to tomorrow
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    setEventDate(tomorrow.toISOString().split("T")[0]);

    // Set default time to 9:00 AM
    setEventTime("09:00");
  }, []);

  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const grandTotal = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <Box
      sx={{
        p: { xs: 1, sm: 2, md: 2 },
        maxWidth: 1200,
        margin: "0 auto",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: { xs: 1, sm: 2, md: 2 },
        }}
      >
        {/* Back Button */}
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate("/user-dashboard")}
          sx={{
            color: "text.primary",
            // mb: 2,
            marginRight: 2,
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            border: "1.5px solid", // Thicker border
            transition: "all 0.3s ease",
            borderColor: "#d32f2f", // Red border color
            "&:hover": {
              backgroundColor: "action.hover",
              transform: "translateX(-4px)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              borderColor: "#d32f2f", // Keep red on hover
              "& .MuiSvgIcon-root": {
                transform: "translateX(-2px)",
              },
            },
            "&:active": {
              transform: "translateX(-2px) scale(0.98)",
            },
          }}
        >
          Back
        </Button>
        {/* <Box
          sx={{
            p: { xs: 1, sm: 1.5 },
            background: "linear-gradient(45deg,#da4040ff 0%, #7e0b0bff 100%)",
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 2,
            ml: 2,
          }}
        >
          <Event sx={{ fontSize: { xs: 24, sm: 20 }, color: "white" }} />
        </Box> */}
        <Typography
          variant={isMobile ? "h5" : "h4"}
          sx={{
            fontWeight: "700",
            background: "linear-gradient(45deg, #da4040ff 0%, #7e0b0bff 90%)",
            backgroundClip: "text",
            textFillColor: "transparent",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Event Booking
        </Typography>
      </Box>

      {cartItems.length === 0 ? (
        <Paper
          sx={{
            p: { xs: 3, sm: 4, md: 5 },
            textAlign: "center",
            borderRadius: 3,
            background: "white",
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          }}
        >
          <Inventory2
            sx={{ fontSize: { xs: 48, sm: 64 }, color: "grey.300", mb: 2 }}
          />
          <Typography
            variant={isMobile ? "body1" : "h6"}
            color="textSecondary"
            gutterBottom
          >
            Your product cart is empty
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Browse our product and add product for your event
          </Typography>
          {/* Added message about booking icon */}
          <Typography
            variant="body2"
            color="primary"
            sx={{
              mb: 2,
              fontStyle: "italic",
              fontWeight: 500,
            }}
          >
            Click top booking icon to view your bookings
          </Typography>
          <Button
            variant="contained"
            sx={{
              borderRadius: 2,
              px: 4,
              background: "linear-gradient(45deg,#da4040ff 0%, #7e0b0bff 100%)",
              fontWeight: 600,
            }}
            onClick={() => {
              navigate("/user-dashboard");
            }}
          >
            Explore Products
          </Button>
        </Paper>
      ) : (
        <Grid container spacing={isMobile ? 3 : 3}>
          <Grid item xs={12} md={8}>
            <Paper
              sx={{
                p: { xs: 1, sm: 2 },
                borderRadius: 3,
                background: "white",
                boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: { xs: "flex-start", sm: "center" },
                  flexDirection: { xs: "column", sm: "row" },
                  mb: 3,
                  gap: { xs: 2, sm: 0 },
                }}
              >
                <Typography
                  variant={isMobile ? "h6" : "h5"}
                  sx={{ fontWeight: 600 }}
                >
                  Your Product ({totalItems})
                </Typography>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleClearCart}
                  startIcon={<Delete />}
                  sx={{ borderRadius: 2 }}
                  size={isMobile ? "small" : "medium"}
                >
                  Clear All
                </Button>
              </Box>

              {cartItems.map((item, index) => (
                <Box
                  key={item.product_id}
                  sx={{
                    p: { xs: 1.5, sm: 1 },
                    mb: 2,
                    borderRadius: 3,
                    background: "#f8f9fa",
                    transition: "all 0.2s",
                    width: { xs: "100%", sm: "494px" }, // ? fixed width here
                    mx: "auto", // center it
                    "&:hover": {
                      background: "#e9ecef",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: { xs: "column", sm: "row" },
                      justifyContent: "space-between",
                      gap: { xs: 2, sm: 0 },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: { xs: "100%", sm: "auto" },
                      }}
                    >
                      {/* <Avatar
                        variant="rounded"
                        sx={{
                          width: { xs: 30, sm: 40 },
                          height: { xs: 30, sm: 40 },
                          mr: 2,
                          background:
                            "linear-gradient(45deg, #da4040ff 0%, #7e0b0bff 100%)",
                          boxShadow: "0 5px 15px rgba(135, 106, 235, 0.3)",
                        }}
                      >
                        <Inventory2
                          sx={{ fontSize: { xs: 24, sm: 32 }, color: "white" }}
                        />
                      </Avatar> */}
                      <Avatar
                        variant="rounded"
                        sx={{
                          width: { xs: 30, sm: 40 },
                          height: { xs: 30, sm: 40 },
                          mr: 2,
                          p: 0,
                          overflow: "hidden",
                          borderRadius: 2,
                          background:
                            "linear-gradient(45deg, #da4040ff 0%, #7e0b0bff 100%)",
                          boxShadow: "0 5px 15px rgba(135, 106, 235, 0.3)",
                        }}
                      >
                        <img
                          src={
                            item.image
                              ? `https://api-productcatelog.bilimbe.in/assets/${encodeURIComponent(
                                  item.image
                                )}`
                              : require("../assets/default-no-image.jpg")
                          }
                          alt="product"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            transform: "scale(1.15)",
                            borderRadius: "8px",
                          }}
                        />
                      </Avatar>
                      <Box sx={{ flexGrow: 1, mr: 2 }}>
                        <Typography
                          variant={isMobile ? "body1" : "h6"}
                          sx={{ fontWeight: 600 }}
                        >
                          {item.category === "Virtual Games"
                            ? `${item.name}-Virtual`
                            : item.category === "Touch Screen"
                            ? `${item.name}-Touch`
                            : item.name}
                        </Typography>

                        {/* PRICE (PER 1 QUANTITY) */}
                        <Typography
                          variant="body2"
                          sx={{
                            color: "gray",
                            fontWeight: 500,
                            fontSize: ".9rem",
                          }}
                        >
                          Price (for 1 quantity):{" "}
                          <CurrencyRupee
                            sx={{ fontSize: "13px", textAlign: "center" }}
                          />
                          {item.price}
                        </Typography>

                        {/* EVENT DURATION INFO */}
                        {item.priceFor && (
                          <Typography
                            variant="body2"
                            sx={{ color: "#555", fontSize: ".85rem", mt: 0.3 }}
                          >
                            {item.priceFor}
                          </Typography>
                        )}

                        {/* TOTAL */}
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 600, fontSize: ".95rem", mt: 0.4 }}
                        >
                          Total:{" "}
                          <CurrencyRupee
                            sx={{ fontSize: "13px", textAlign: "center" }}
                          />
                          {item.price * item.quantity}
                        </Typography>
                      </Box>
                      {/* 
                      <Box sx={{ flexGrow: 1, mr: 2 }}>
                        <Typography
                          variant={isMobile ? "body1" : "h6"}
                          sx={{ fontWeight: 600 }}
                        >
                          {item.category === "Virtual Games"
                            ? `${item.name}-Virtual`
                            : item.category === "Touch Screen"
                            ? `${item.name}-Touch`
                            : item.name}
                        </Typography>
                      </Box> */}
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: { xs: "100%", sm: "auto" },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          background: "white",
                          borderRadius: 2,
                          p: 0.5,
                          border: "1px solid #dee2e6",
                          order: { xs: 2, sm: 1 },
                        }}
                      >
                        <IconButton
                          size="small"
                          onClick={() =>
                            decrementQuantity(item.product_id, item.quantity)
                          }
                          disabled={item.quantity <= 1}
                        >
                          <Remove fontSize="small" />
                        </IconButton>

                        <TextField
                          type="number"
                          value={item.quantity}
                          onChange={(e) =>
                            handleQuantityChange(
                              item.product_id,
                              e.target.value
                            )
                          }
                          inputProps={{
                            min: 1,
                            style: {
                              textAlign: "center",
                              alignItems: "center",
                              width: 30,
                              padding: "4px",
                            },
                          }}
                          variant="standard"
                          sx={{ mx: 0.5 }}
                          size="small"
                        />

                        <IconButton
                          size="small"
                          onClick={() =>
                            incrementQuantity(item.product_id, item.quantity)
                          }
                        >
                          <Add fontSize="small" />
                        </IconButton>
                      </Box>

                      <IconButton
                        onClick={() => handleRemove(item.product_id)}
                        sx={{
                          ml: { xs: 0, sm: 2 },
                          color: "#dc3545",
                          order: { xs: 1, sm: 2 },
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper
              sx={{
                p: { xs: 1, sm: 2 },
                borderRadius: 3,
                background: "white",
                boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                position: { xs: "static", md: "sticky" },
                top: 20,
              }}
            >
              <Typography
                variant={isMobile ? "h6" : "h5"}
                sx={{ fontWeight: 600, mb: 2 }}
              >
                Booking Summary
              </Typography>

              <Box sx={{ mb: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="body2" color="textSecondary">
                    Total Product Items
                  </Typography>
                  <Typography variant="body2" fontWeight="600">
                    {totalItems}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="body2" color="textSecondary">
                    Product Types
                  </Typography>
                  <Typography variant="body2" fontWeight="600">
                    {cartItems.length}
                  </Typography>
                </Box>

                <Divider sx={{ my: 1 }} />

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="body2">Setup Availability</Typography>
                  <Chip label="Confirmed" color="success" size="small" />
                </Box>
              </Box>
              <Divider sx={{ my: 1 }} />

              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
              >
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  Total Amount
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 700, color: "#D32F2F" }}
                >
                  <CurrencyRupee
                    sx={{ fontSize: "13px", textAlign: "center" }}
                  />
                  {grandTotal}
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  color: "#B71C1C",
                  fontWeight: 600,
                  mt: 1,
                  background: "rgba(255, 0, 0, 0.08)",
                  p: "6px 10px",
                  borderRadius: "6px",
                }}
              >
                * Prices may vary based on event time & distance. 18% GST will
                be added separately.
              </Typography>
              <Divider sx={{ my: 1 }} />

              <Box
                sx={{
                  backgroundColor: "#e9ecef",
                  p: 2,
                  borderRadius: 2,
                  mb: 1,
                }}
              >
                <Typography variant="body2" sx={{ fontStyle: "italic" }}>
                  Our team will contact you to confirm booking and setup
                  details.
                </Typography>
              </Box>

              <Button
                variant="contained"
                fullWidth
                onClick={() => setBookingFormOpen(true)}
                sx={{
                  py: 1.5,
                  borderRadius: 2,
                  fontWeight: 600,
                  background:
                    "linear-gradient(45deg, #da4040ff 0%, #7e0b0bff 100%)",
                }}
                size={isMobile ? "large" : "medium"}
              >
                Book Now
              </Button>
            </Paper>
          </Grid>
        </Grid>
      )}

      <BookingForm
        key={cartItems.length}
        open={bookingFormOpen}
        onClose={() => setBookingFormOpen(false)}
        selectedProduct={cartItems}
        userDetails={userDetails}
        totalPrice={grandTotal}
      />
    </Box>
  );
};

export default CartPage;
